import { useCourse } from '@/composables/course'
import { useAppSettings } from './useAppSettings'
import { useAccountStore } from '@/stores/account'
import { runSafe } from './app-init.helpers'

export function useAppInit(options?: { onSettingsLoaded?: () => void }) {
  const { fetchAllAvailableLocales } = useCourse()
  const { loadSettings } = useAppSettings()

  const applyAppSettings = async () => {
    if (!process.client) return
    await runSafe(async () => {
      await loadSettings()
      options?.onSettingsLoaded?.()
    }, 'Failed to load app settings')
  }

  const loadGlobalLocales = () =>
    runSafe(() => fetchAllAvailableLocales(), 'Failed to load global course locales')

  const detectAccount = async () => {
    const accountStore = useAccountStore()
    await runSafe(async () => {
      // by.bibleawr.com is a locale-specific site for Belarus.
      // geoDetect is disabled — always route to the Belarusian school account.
      await accountStore.findAccountByCountry('by')
    }, 'Failed to detect account')
  }

  const initializeApp = async () => {
    await applyAppSettings()
    await detectAccount()
    loadGlobalLocales()
  }

  return {
    initializeApp,
    applyAppSettings,
    detectAccount,
    loadGlobalLocales,
  }
}
